<template>
	<window-view title="Opgave" v-on="$listeners" :width="880" :actions="_actions">
		<tabs-view :tabs="_tabs" v-model="tab" style="margin-top: -10px;" />

		<panel-view v-if="tab == 'details'">
			<panel-sep-view>
				<grid-view :cols="['1fr', '1.5fr', '1.5fr']">
					<input-view v-model="m.ref" label="Sagsnr" />
					<input-view v-model="m.received" label="Modtaget" />
					<div>
						<input-view v-model="m.deadline" label="Deadline" />
						<switch-view v-model="m.urgent" label="Haster" style="width: 100%;" />
					</div>
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view :cols="['1fr', '1fr', '2fr']">
					<customer-search-view v-model="m.customer_id" label="Kunde" key="customer" />
					<select-view v-model="m.manager_id" label="Byggeleder" :options="_managers" />
					<input-view v-model="m.builder" label="Bygherre" />
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view :cols="['3fr', '1fr']">
					<input-view v-model="m.address" label="Adresse" />
					<select-view v-model="m.checked" label="Efterset" :options="jobs.checked()" />
				</grid-view>
				<grid-view :cols="['1fr', '2fr', '1fr']">
					<input-view v-model="m.zip" label="Postnr" />
					<input-view v-model="m.city" label="By" />
					<select-view v-model="m.handover" label="Afleveret" :options="jobs.handover()" />
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view :cols="['1fr', '1fr']">
					<select-view v-model="m.type" label="Type" :options="jobs.types()" />
					<select-view v-model="m.color" label="Farve" :options="jobs.colors()" />
				</grid-view>
				<grid-view :cols="['1fr']">
					<input-view type="text" v-model="m.desc" label="Beskrivelse" :height="200" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
		<panel-view v-if="tab == 'price'">
			<panel-sep-view>
				<grid-view>
					<lines-view v-model="m._embedded.lines" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
		<panel-view v-if="tab == 'photos.before'">
			<panel-sep-view>
				<grid-view>
					<photos-view key="before" v-model="m._embedded.photos.before" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
		<panel-view v-if="tab == 'photos.after'">
			<panel-sep-view>
				<grid-view>
					<photos-view key="after" v-model="m._embedded.photos.after" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import job from '../../../model/job';
	import customer from '../../../model/customer';
	import manager from '../../../model/manager';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				customer: null,
				managers: null,
				tab: 'details',
				jobs: job,
				m: job.model()
			};
		},
		watch: {
			'm.customer_id': {
				async handler(n) {
					console.log('customer_id changed');

					if (n === null) {
						this.customer = null;
					} else {
						this.customer = await customer.read(n);
					}
				}
			}
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							console.log('job', this.m);
							return self.submit(this.m);
						}
					}
				];
			},
			_tabs() {
				return [
					{
						label: 'Detaljer',
						value: 'details'
					},
					{
						label: 'Pris',
						value: 'price'
					},
					{
						label: 'Billeder [før]',
						value: 'photos.before'
					},
					{
						label: 'Billeder [efter]',
						value: 'photos.after'
					}
				];
			},
			_managers() {
				if (this.customer === null) return [];

				const self = this;

				var r = [
					{
						label: 'Opret ny',
						action() {
							console.log('new manager');
							manager.open({ customer_id: self.m.customer_id }, async (model) => {
								self.customer = await customer.read(self.m.customer_id);
								self.m.manager_id = model.id;
							});
						}
					},
					{
						label: 'Ryd',
						action() {
							console.log('clear manager');
							self.m.manager_id = null;
						}
					}
				];

				if (this.customer._embedded.managers.length > 0) r.push(null);

				// Autoselect
				if (this.customer._embedded.managers.length == 1) {
					this.m.manager_id = this.customer._embedded.managers[0].id;
				}

				return r.concat(this.customer._embedded.managers.map((item) => {
					return {
						label: item.name,
						value: item.id
					};
				}));
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>

</style>